/**
 * Alinha com o backend: `${accountType}:${userId}` (ex.: profissionalSaude:64abc...).
 */
export function getMyUserKeyFromStorage() {
  const raw = localStorage.getItem('user');
  if (!raw) return null;
  try {
    const data = JSON.parse(raw);
    if (data.user?.id != null) return `user:${String(data.user.id)}`;
    if (data.colaborador?.id != null) return `colaborador:${String(data.colaborador.id)}`;
    if (data.profissionalSaude?.id != null) return `profissionalSaude:${String(data.profissionalSaude.id)}`;
  } catch {
    return null;
  }
  return null;
}
